window.prereceptIndexSearch = async () => {
	const lastName = document.querySelector('[name=last_name]').value
	const firstName = document.querySelector('[name=first_name]').value
	const params = new URLSearchParams()
	params.append('performer_name',lastName+'　'+firstName)
	const response = await axios.post('/prerecept/index',params)
	if(response.data.result==='OK')
	{
		location.href = '/prerecept/search_result'
	}
	else
	{
		document.getElementById('not_found_message').style.display = 'flex'
	}
}

window.prereceptSearchSet = async (id) => {
	const params = new URLSearchParams()
	params.append('id',id)
	const response = await axios.post('/prerecept/search_result',params)
	if(response.data.result==='OK')
	{
		location.href = '/prerecept/edit/step1/'+id
	}
}

const dropZoneDragover = (e) => {
	const dropArea = document.getElementById('drop_area')
	e.stopPropagation()
	e.preventDefault()
	dropArea.style.background = '#e1e7f0'
}
const dropZoneDragleave = (e) => {
	const dropArea = document.getElementById('drop_area')
	e.stopPropagation()
	e.preventDefault()
	dropArea.style.background = '#ffffff';
}
const dropZoneDrop = (e) => {
	const dropArea = document.getElementById('drop_area')
	const formFiles = document.getElementById('files')
	const fileList = document.getElementById('file_list')
	e.stopPropagation()
	e.preventDefault()
	dropArea.style.background = '#ffffff'
	const files = e.dataTransfer.files
	formFiles.files = files
	while(fileList.lastChild){
		fileList.removeChild(fileList.lastChild);
	}
	for(var file of files) {
		const item = document.createElement('li')
		item.innerText = file.name
		fileList.append(item)
	}
	document.getElementById('start_upload').disabled = false
}

window.prereceptStep1Initialize = () => {
	const dropZone = document.getElementById('drop_zone')
	const formFiles = document.getElementById('files')
	const fileList = document.getElementById('file_list')
	formFiles.value = ''
	const item = document.createElement('li')
	item.innerText = 'ここにドラッグしてください'
	while(fileList.lastChild){
		fileList.removeChild(fileList.lastChild);
	}
	fileList.append(item)
	dropZone.removeEventListener('dragover', dropZoneDragover)
	dropZone.removeEventListener('dragleave', dropZoneDragleave)
	dropZone.removeEventListener('drop', dropZoneDrop)
	dropZone.addEventListener('dragover', dropZoneDragover, false)
	dropZone.addEventListener('dragleave', dropZoneDragleave, false)
	dropZone.addEventListener('drop', dropZoneDrop, false)
	document.getElementById('start_upload').disabled = true
}

window.prereceptStep1OpenFileDialog = () => {
	document.getElementById('files').click()
}

const step1Progress = (e) => {
	const progress = (e.loaded/e.total*100).toFixed(1)
//	document.getElementById('progress_bar').style.width = ''+progress+'%'
//	document.getElementById('progress_text').innerHTML = ''+progress+'%'
	document.getElementById('uploadRatio').innerText = progress;
	document.getElementById('uploadBar').style.width = progress + '%';
}

window.prereceptStep1FileOnChange = async () => {
	const formFile = document.getElementById('files').files;
	const fileList = document.getElementById('file_list')
	while(fileList.lastChild){
		fileList.removeChild(fileList.lastChild);
	}
	for(var file of formFile) {
		const item = document.createElement('li')
		item.innerText = file.name
		fileList.append(item)
	}
	document.getElementById('start_upload').disabled = false;
}

window.prereceptStep1Save = async () => {
	const formFile = document.getElementById('files')
	const formData = new FormData()
	for(let index=0;index<formFile.files.length;index++) {
		formData.append(('file'+(index+1)), formFile.files[index])
	}
	const config = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		onUploadProgress:step1Progress,
	}
	//document.getElementById('confirm_area').style.display = 'none'
	//document.getElementById('upload_area').style.display = 'none'
	//document.getElementById('progress_area').style.display = 'block'
	document.getElementById('uploadModal').classList.add('on')

	const response = await axios.post('/prerecept/edit/step1',formData,config)
	if(response.data.result==='OK')
	{
		location.href = '/prerecept/edit/step2'
	}
}

window.prereceptStep2Save = async (next) => {
	const params = new URLSearchParams()
	const fileCount = Number(document.getElementById('file_count').value)
	for(let index=0; index<fileCount; index++) {
		const fileNo = (index+1)
		params.append('movie_flg_'+fileNo, document.querySelector('[name=movie_flg_'+fileNo+']:checked').value)
		params.append('sound_flg_'+fileNo, document.querySelector('[name=sound_flg_'+fileNo+']:checked').value)
		params.append('application_id_'+fileNo, document.querySelector('[name=application_id_'+fileNo+']').value)
		params.append('remarks_'+fileNo, document.querySelector('[name=remarks_'+fileNo+']').value)
	}
	const response = await axios.post('/prerecept/edit/step2',params)
	if(response.data.result==='OK')
	{
		location.href = '/prerecept/edit/'+next
	}

}
